import React from "react";
import "../../fileChartHeader.scss";
const Head = (
	{
		className = '',
		headingLabel = '',
		_handleClick,
		options=[]
	}
) => {

	
	return (
		<>
			<div className={`head d-flex align-items-center ${className}`}>
				<div className="left-col">
					<h2>
						{headingLabel}
					</h2>
				</div>
				<div className="right-col ms-auto">
					<div className="dropdown">
						<select className="form-select" onChange={($event) => {_handleClick($event.target.value)}}>
							{options && options.map((item, index) => {
								return (<option key={index} value={item.value}>
									{item.label}</option>);
							})}
						</select>
					</div>
				</div>
			</div>
		</>
	);

}
export default Head;